import {
  Root as DimeDropdownMenu,
  Trigger as DimeDropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';

import {
  DimeDropdownMenuCheckboxItem,
  DimeDropdownMenuContent,
  DimeDropdownMenuItem,
  DimeDropdownMenuSeparator,
} from '../DimeDropdownMenu.js';
import { cn } from '../lib/utils.js';
import { DataTableColumnsButton } from './DataTableColumnsButton.js';
import type { ViewOptionsTable } from './view-options-table.js';

export function DataTableViewOptions({
  table,
  menuClassName,
}: Readonly<{ table: ViewOptionsTable; menuClassName?: string }>) {
  // getCanHide() is the full contract; an id+cell column (no accessorFn) is hideable too.
  const hideableColumns = table.getAllLeafColumns().filter((column) => column.getCanHide());

  if (hideableColumns.length === 0) {
    return null;
  }

  const allVisible = hideableColumns.every((column) => column.getIsVisible());

  return (
    <DimeDropdownMenu>
      <DimeDropdownMenuTrigger asChild>
        <DataTableColumnsButton />
      </DimeDropdownMenuTrigger>
      <DimeDropdownMenuContent align="end" className={cn('min-w-[150px]', menuClassName)}>
        <DimeDropdownMenuItem
          disabled={allVisible}
          onSelect={(event) => {
            event.preventDefault();
            for (const column of hideableColumns) column.toggleVisibility(true);
          }}
        >
          Show All
        </DimeDropdownMenuItem>
        <DimeDropdownMenuSeparator />
        {hideableColumns.map((column) => (
          <DimeDropdownMenuCheckboxItem
            key={column.id}
            className="capitalize"
            checked={column.getIsVisible()}
            onCheckedChange={(value) => column.toggleVisibility(!!value)}
            onSelect={(event) => event.preventDefault()}
          >
            {column.columnDef.meta?.label ?? column.id}
          </DimeDropdownMenuCheckboxItem>
        ))}
      </DimeDropdownMenuContent>
    </DimeDropdownMenu>
  );
}
